export const getVendorListMutation = (builder) => ({
  getVendorList: builder.mutation({
    query: ({ search, enterprise_id,  page, limit, sortBy, sortOrder, }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/get_list_of_vendor",
        method: "GET",
        params: { search, enterprise_id, page, limit, sortBy, sortOrder, },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
